import { render, staticRenderFns } from "./CotPropostaAccessoProrogheModalViewComponent.vue?vue&type=template&id=65c7cd3e"
import script from "./CotPropostaAccessoProrogheModalViewComponent.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoProrogheModalViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports